import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom
import { toast } from 'react-toastify';
import { deleteApi } from '../../Services/apiService';



const DeleteModal = ({ setDeleteModal,userDetails,title,comp }) => {

  console.log('this is userdetails',userDetails);
    const navigate = useNavigate();
    const closeModal = () => {
        setDeleteModal(true);
    };
    const [loader, setLoader] = useState(false)
    const handleDelete = async () => {
        setLoader(true)
        try {
          // Dynamically construct the API endpoint based on `comp`
          const endpoint = comp === 'user' 
              ? `/admin/user/` 
              : comp === 'meditation' 
              ? `/admin/meditation/` 
              : `/admin/default/`; // Add a fallback endpoint if needed
  
          const response = await deleteApi(`${endpoint}${userDetails}`, { id: userDetails });
  
            if (response?.statusCode === 200) {
            toast.success(response?.message);
            setLoader(false)
            setDeleteModal(false);
          } else {
            setLoader(false)
          }
        } catch (error) {
          setLoader(false)
        }
      };
    return (
        <>
        <div className='modal-header'>
        <span> <img src={window.getPublicUrl("/assets/images/del-icon.svg")} alt='' /></span>
        <button className='close-button' onClick={() => setDeleteModal(false)}><img src={window.getPublicUrl("/assets/images/gray-cross.svg")} alt='' /></button>

        </div>
            <div className='modal-body'>
            <h3> Are you sure you want to delete {title}?</h3>
            </div>
            <div className='modal-footer'>
                <button onClick={() => setDeleteModal(false)}>Cancel</button>
                <button className='delete' disabled={loader} onClick={() => handleDelete()}>
            {loader && <div className="spinner-border" role="status"><span className="sr-only"></span></div>}
               Delete</button>
            </div>
        </>
    );
}

export default DeleteModal;